module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > 3G Stick.3c56d10f.jpg";